'use client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { USER_QUERIES } from '../../infrastructure/user/utils/queries';

type UseGetUserMeOptions = {
  enabled?: boolean;
};

export const useUserService = () => {
  const useGetUserMe = ({ enabled = true }: UseGetUserMeOptions = {}) => {
    return useQuery({
      ...USER_QUERIES.getMe(),
      enabled,
    });
  };

  return {
    useGetUserMe,
  };
};

export const useUserMutation = () => {
  const useGetUserMeMutation = () => {
    const queryClient = useQueryClient();
    return useMutation(USER_QUERIES.getMeMutation(queryClient));
  };

  const useUpdateUserMutation = () => {
    return useMutation(USER_QUERIES.updateUserMutation());
  };

  return {
    useGetUserMeMutation,
    useUpdateUserMutation,
  };
};
